import * as Yup from 'yup';
import { DeviceType } from '@models';

export function useValidationSchema() {
  return Yup.object<DeviceType>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
  }) as Yup.Schema<DeviceType>;
}
